import React, { useState } from 'react';
import { RingChart } from './RingChart';
interface DemographicChartsProps {
  genderData: {
    male: number;
    female: number;
    other: number;
  };
  ageData: {
    '18-24': number;
    '25-34': number;
    '35-44': number;
    '45-54': number;
    '55-64': number;
    '65+': number;
    unknown: number;
  };
}
export const DemographicCharts: React.FC<DemographicChartsProps> = ({
  genderData,
  ageData
}) => {
  const [activeGenderSegment, setActiveGenderSegment] = useState<string | null>(null);
  const [activeAgeSegment, setActiveAgeSegment] = useState<string | null>(null);
  const genderChartData = [{
    label: 'Male',
    value: genderData.male,
    color: '#D1005D'
  }, {
    label: 'Female',
    value: genderData.female,
    color: '#FF6B6B'
  }, {
    label: 'Other',
    value: genderData.other,
    color: '#9CA3AF'
  }];
  const ageChartData = [{
    label: '18-24',
    value: ageData['18-24'],
    color: '#D1005D'
  }, {
    label: '25-34',
    value: ageData['25-34'],
    color: '#4BC0C0'
  }, {
    label: '35-44',
    value: ageData['35-44'],
    color: '#FFB347'
  }, {
    label: '45-54',
    value: ageData['45-54'],
    color: '#A78BFA'
  }, {
    label: '55-64',
    value: ageData['55-64'],
    color: '#F87171'
  }, {
    label: '65+',
    value: ageData['65+'],
    color: '#34D399'
  }, {
    label: 'Unknown',
    value: ageData.unknown,
    color: '#9CA3AF'
  }];
  return <div className="bg-white p-6 rounded-sm shadow-[0_2px_8px_rgba(0,0,0,0.05)] border border-[#F2F3F5]" data-id="element-140" data-mp="3e8wrcd5k6sq0">
      <h2 className="text-lg font-medium text-[#141617] mb-6" data-id="element-141" data-mp="3j1y5uk1usq92">
        Demographic Distribution
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-142" data-mp="34dbrakk1w2iw">
        <RingChart data={genderChartData} title="Gender Distribution" activeSegment={activeGenderSegment} onSegmentHover={setActiveGenderSegment} data-id="element-143" data-mp="399sdvablq8tv" />
        <RingChart data={ageChartData} title="Age Distribution" activeSegment={activeAgeSegment} onSegmentHover={setActiveAgeSegment} data-id="element-144" data-mp="2vcx2vcbsi7b6" />
      </div>
    </div>;
};